import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { Observable } from 'rxjs';
import { GeographicArea } from '../../../_models/user/geographicArea';
import { JurisdictionalAgenciesService } from './jurisdictional-agencies.service';

@Injectable({
  providedIn: 'root'
})
export class JurisdictionalAgenciesResolver  {
  constructor(private jurisdictionalAgenciesService: JurisdictionalAgenciesService) {
  }

  resolve(route: ActivatedRouteSnapshot, routerState: RouterStateSnapshot): Observable<GeographicArea[]> {
    return this.jurisdictionalAgenciesService.getJurisdictionalAgencies();
  }
}
